import React, { useEffect, useState } from "react";
import "./DashBoardListStyle.css";
import { useLocation, useNavigate } from "react-router-dom";
import { LocalStorageServices } from "../../../../../services/localStorageServices";
import {
  getServicesByStatus,
  multiSelectApproveReject,
} from "../../../../../api/dashboardApis";
import {
  Box,
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Paper,
  Skeleton,
  Stack,
  TextField,
} from "@mui/material";
import { PiEye } from "react-icons/pi";
import { IoArrowBackSharp } from "react-icons/io5";
import { SuccessToast } from "../../../../../toast/toasts";
import CustomModal from "../../../../../components/custom_modal/CustomModal";
import CustomTextArea from "../../../../../components/custom_text_area/CustomTextArea";

function DashBoardList({ update_notification_read, viewAllAction, is_border }) {
  const location = useLocation();
  const navigate = useNavigate();

  const { status } = location.state || {}; // Use optional chaining to avoid errors if state is undefined

  let baseRouteUrl = `/ecrs_portal/${LocalStorageServices.getUserRole()}/`;

  const [loading, setLoading] = useState(true);

  const [notificationList, setNotificationList] = useState([]);

  const [actionLoading, setActionLoading] = useState(false);

  // Popup state
  const [openActionDialog, setOpenActionDialog] = useState(false);
  const [currentAction, setCurrentAction] = useState(""); // Approve / Reject
  const [actionMessage, setActionMessage] = useState(""); // User typed message

  const [selectedIds, setSelectedIds] = useState([]);
  const [selectAll, setSelectAll] = useState(false);

  const buildUniqueId = (item) =>
    `${item.booking_id}_${item.issue_date}_${item.type}`;

  const toggleSelectItem = (item) => {
    const id = buildUniqueId(item);

    if (selectedIds.includes(id)) {
      setSelectedIds(selectedIds.filter((x) => x !== id));
    } else {
      setSelectedIds([...selectedIds, id]);
    }
  };

  const toggleSelectAll = () => {
    if (selectAll) {
      setSelectedIds([]);
      setSelectAll(false);
    } else {
      const allIds = notificationList.map(buildUniqueId);
      setSelectedIds(allIds);
      setSelectAll(true);
    }
  };

  const getServiceType = (type) => {
    switch (type.toLowerCase()) {
      case "flight":
        return 1;
      case "package":
        return 2;
      case "cab":
        return 3;
      case "passport":
        return 4;
      case "visa":
        return 5;
      case "hotel":
        return 6;
      case "train":
        return 7;
      case "insurance":
        return 8;
    }
  };

  const getStatusFromAction = (actionType) => {
    switch (actionType.toLowerCase()) {
      case "approve":
        return 5;
      case "reject":
        return 6;
    }
  };

  const getCurrentDateTime = () => {
    const now = new Date();

    const pad = (n) => (n < 10 ? "0" + n : n);

    return (
      pad(now.getDate()) +
      "-" +
      pad(now.getMonth() + 1) +
      "-" +
      now.getFullYear() +
      " " +
      pad(now.getHours()) +
      ":" +
      pad(now.getMinutes()) +
      ":" +
      pad(now.getSeconds())
    );
  };

  const handleConfirmAction = () => {
    setOpenActionDialog(false);

    actionButtonFunction(currentAction, actionMessage);

    setActionMessage(""); // clear input
  };

  const actionButtonFunction = (actionType, commentMessage) => {
    // Find items that match selectedIds
    const selectedItems = notificationList.filter((item) =>
      selectedIds.includes(buildUniqueId(item))
    );

    const payload = {
      services: selectedItems.map((item) => ({
        bookingId: item.booking_id,
        pnr: item.module_number,
        service_type: getServiceType(item.type),
        status: getStatusFromAction(actionType),
        comments: commentMessage,
        review_date: getCurrentDateTime(),
      })),
    };

    console.log(selectedItems, "selectedItems");
    console.log("API Payload:", payload);

    try {
      setActionLoading(true);

      multiSelectApproveReject(payload) // Assuming it expects a payload
        .then((response) => {
          SuccessToast(response?.data?.message);

          if (status) {
            const payload = { status };
            fetchServicesByStatus(payload);
          }
        })
        .catch((error) => {
          console.error("API Error:", error);
        });
    } catch (error) {
      console.error("Error sending api", error);
    } finally {
      setActionLoading(false);
    }
  };

  // API Call for fetching data
  const fetchServicesByStatus = async (payload) => {
    try {
      setLoading(true);
      const responseServicesStatus = await getServicesByStatus(payload); // Assuming it expects a payload
      if (responseServicesStatus?.data?.status) {
        setNotificationList(responseServicesStatus?.data?.data);
      } else {
        setNotificationList([]);
      }
    } catch (error) {
      setNotificationList([]);
      console.error("Error fetching services by status:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (status) {
      const payload = { status };
      fetchServicesByStatus(payload);
    }
  }, [location]);

  const navigate_to_module = (item, module, filter_data) => {
    // dispatch(updateNotificationRedirect({module,filter_data}))

    if (module === "Package") {
      navigate(
        baseRouteUrl +
          `process_ecr/${item.booking_id}/view_package?is_redirect=true`
      );
    } else if (module === "Flight") {
      navigate(
        baseRouteUrl +
          `process_ecr/${item.booking_id}/view_flight_ticket?is_redirect=true`
      );
    } else if (module === "Hotel") {
      navigate(
        baseRouteUrl +
          `process_ecr/${item.booking_id}/view_hotel_booking?is_redirect=true`
      );
    } else if (module === "Cab") {
      navigate(
        baseRouteUrl +
          `process_ecr/${item.booking_id}/view_cab?is_redirect=true`
      );
    } else if (module === "Passport") {
      navigate(
        baseRouteUrl +
          `process_ecr/${item.booking_id}/view_passport?is_redirect=true`
      );
    } else if (module === "Visa") {
      navigate(
        baseRouteUrl +
          `process_ecr/${item.booking_id}/view_visa?is_redirect=true`
      );
    } else if (module === "Insurance") {
      navigate(
        baseRouteUrl +
          `process_ecr/${item.booking_id}/view_travel_insurance?is_redirect=true`
      );
    } else if (module === "Train") {
      navigate(
        baseRouteUrl +
          `process_ecr/${item.booking_id}/view_train?is_redirect=true`
      );
    }
  };

  return (
    <>
      <Paper
        sx={{ maxHeight: `calc(100vh - 160px)`, overflowY: "auto", padding: 2 }}
      >
        <IoArrowBackSharp
          className="flight_ticket_form_back"
          style={{ marginLeft: "10px" }}
          onClick={() => {
            navigate(`${baseRouteUrl}dashboard`);
          }}
        />

        {/* Top Action Bar */}
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
          sx={{ mb: 2, display: notificationList.length > 0 ? "flex" : "none" }}
        >
          {/* Select All */}
          <Stack direction="row" spacing={1} alignItems="center">
            <Checkbox
              checked={selectAll}
              onChange={toggleSelectAll}
              size="small"
            />
            <p className="header_notification_message">Select All</p>
          </Stack>

          {/* Approve + Reject Buttons */}
          <Stack direction="row" spacing={1}>
            {/* <Button
              variant="contained"
              color="success"
              size="small"
              disabled={selectedIds.length === 0 || actionLoading}
              onClick={() => {
                setCurrentAction("Approve");
                setOpenActionDialog(true);
              }}
            >
              Approve
            </Button>

            <Button
              variant="contained"
              color="error"
              size="small"
              disabled={selectedIds.length === 0 || actionLoading}
              onClick={() => {
                setCurrentAction("Reject");
                setOpenActionDialog(true);
              }}
            >
              Reject
            </Button> */}

            <button
              className="flight_ticket_form_save_button"
              onClick={() => {
                setCurrentAction("Approve");
                setOpenActionDialog(true);
              }}
              disabled={selectedIds.length === 0 || actionLoading}
            >
              Approve
            </button>
            <button
              className="flight_ticket_form_save_button"
              onClick={() => {
                setCurrentAction("Reject");
                setOpenActionDialog(true);
              }}
              disabled={selectedIds.length === 0 || actionLoading}
            >
              Reject
            </button>
          </Stack>
        </Stack>

        {/* Notification List */}
        {!loading && notificationList?.length > 0 ? (
          <div
            style={{
              maxHeight: "calc(100vh - 260px)",
              overflowY: "auto",
              padding: "10px",
            }}
          >
            {notificationList.map((item, index) => (
              <div
                key={index}
                className="header_notification_list_sub_container"
                style={{ display: "flex", gap: "10px" }}
              >
                {/* Row Checkbox */}
                <Checkbox
                  checked={selectedIds.includes(buildUniqueId(item))}
                  onClick={(e) => {
                    e.stopPropagation();
                    toggleSelectItem(item);
                  }}
                  size="small"
                />

                {/* Actual Item Content */}
                <div
                  style={{ flexGrow: 1 }}
                  onClick={(e) => {
                    e.stopPropagation(); // prevent parent row click
                    navigate_to_module(item, item?.type, item?.module_number);
                  }}
                >
                  <div className="header_notification_list_flex">
                    <p className="header_notification_message">{item?.type}</p>
                    <p>--</p>
                    <p className="header_notification_user_name">
                      {item?.module_number}
                    </p>
                  </div>

                  <div className="header_notification_list_flex">
                    <p className="header_notification_message">Client</p>
                    <p>--</p>
                    <p className="header_notification_message">
                      {item?.get_client?.CI_name}
                    </p>
                  </div>
                </div>

                <Button
                  onClick={(e) => {
                    e.stopPropagation(); // prevent parent row click
                    navigate_to_module(item, item?.type, item?.module_number);
                  }}
                >
                  <PiEye className="packages_action_view" />
                </Button>
              </div>
            ))}
          </div>
        ) : loading ? (
          /* Skeleton Loader */
          <div
            style={{
              maxHeight: "calc(100vh - 170px)",
              overflowY: "auto",
              padding: "10px",
            }}
          >
            {[...Array(9)].map((_, index) => (
              <div
                key={index}
                className="header_notification_list_sub_container"
                style={{ padding: "10px" }}
              >
                <Skeleton variant="rectangular" height={50} />
              </div>
            ))}
          </div>
        ) : (
          /* No data */
          <div
            className="header_notification_list_sub_container"
            style={{ margin: "20px auto" }}
          >
            <p className="header_notification_not_found">No data found</p>
          </div>
        )}
      </Paper>

      <CustomModal
        open={openActionDialog}
        handleClose={() => {
          setOpenActionDialog(false);
        }}
        body={
          <div>
            <div>
              <p className="manager_level_modal_label">
                Comment<span className="label_required_remark">*</span>
              </p>
              <CustomTextArea
                autoFocus
                rows={10}
                placeholder={"Enter a comment"}
                onChange={(e) => setActionMessage(e.target.value)}
              />
            </div>
            <div className="manager_level_modal_form_single_row_alignment">
              <button
                className="manager_level_modal_form_reset_button"
                onClick={() => {
                  setOpenActionDialog(false);
                }}
              >
                Cancel
              </button>

              <button
                className="manager_level_modal_form_update_button"
                disabled={actionLoading || actionMessage.trim().length === 0}
                onClick={handleConfirmAction}
              >
                {actionLoading ? "Submitting..." : "Submit"}
              </button>
            </div>
          </div>
        }
        title={`Confirm ${currentAction} of ${selectedIds.length} Item${
          selectedIds.length > 1 ? "s" : ""
        }`}
      />
    </>
  );
}

export default DashBoardList;
